export enum EnumReminderType {
    AnswerKey = 'ANSWER_KEY',
    Events = 'EVENTS',
    Exams = 'EXAMS',
    Others = 'OTHERS',
    Payments = 'PAYMENTS',
    Publications = 'PUBLICATIONS',
    Registration = 'REGISTRATION',
    Reviews = 'REVIEWS',
    Studies = 'STUDIES'
}